module.exports = __webpack_public_path__ + "img/goals.ce287471.svg";